module.exports = __webpack_public_path__ + "img/1.e866ef92.svg";